import { Mapper } from "../../../../base/utils/mapper";

import { PerfilModel }
from "../../../../domain/models/configuration/perfil.model";

import { PerfilEntity }
from "../entities/perfil.entity";

export class PerfilImplementationRepositoryMapper
extends Mapper<
PerfilEntity,
PerfilModel
> {

    mapFrom(param:
    PerfilEntity):
    PerfilModel {

        return {
            ...param
        };
    }

    mapTo(param:
    PerfilModel):
    PerfilEntity {

        return {
            ...param
        };
    }
}